/**
 * Checkbox Template
 * @returns string
 */
export default (): string => {
  return '<span class="checkmark"></span>';
};
